module.exports = __webpack_public_path__ + "static/img/level13.68c13dce.png";